import { c as _c } from "react/compiler-runtime";
import { Icon } from "@justhome/react-ui";
import clsx from "clsx";
interface InfoCardProps {
  title: string;
  description?: string;
  list?: string[];
  className?: string;
}
const InfoCard = t0 => {
  const $ = _c(13);
  const {
    title,
    description,
    list,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("rounded-3xs bg-info-50 p-s m:p-3s text-left", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h3 className="mb-s text-body-2 font-semibold">{title}</h3>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = description && <p className="mb-s text-body-2">{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== list) {
    t4 = list && <ul className="space-y-2xs text-body-2">{list.map(_temp)}</ul>;
    $[6] = list;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default InfoCard;
function _temp(item) {
  return <li key={item} className="flex items-center gap-2xs"><Icon type="CheckSmall" size="24" className="text-info-700" />{item}</li>;
}